export default __webpack_public_path__ + "static/media/Dave.07f4c7e5.jpeg";